module.exports = __webpack_public_path__ + "r-v3/img/google_docs.51db3fe4.svg";